//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormulaHeader from '../../layout/components/header'
import { mapMutations } from 'vuex'
// import { formulaDetail } from "@/server/oldformula";
// import { getCollectInfoById } from "@/server/home/index";
// import runGlobal from "../../../../static/yongyaochaxun/globalJS";
import { DatetimePicker, Field, Dialog, Overlay } from 'vant'
import 'vant/lib/datetime-picker/style'
// import "vant/lib/overlay/style";
import 'vant/lib/dialog/style'
import 'vant/lib/overlay/style'
// import { Overlay } from 'vant';

export default {
  name: 'PregnancyWeek',
  components: {
    FormulaHeader,
    [DatetimePicker.name]: DatetimePicker,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [Overlay.name]: Overlay
  },
  filters: {

  },
  data() {
    return {
      showOverlay: false,
      formulaId: null, // 公式的id
      formulaInfo: {}, // 公式的详情
      isExpand: 0, // 描述是否展开 0不显示显示展开， 1显示展开 2显示收起
      collectStatus: false, // 是否收藏
      lastSadDate: '', // 末次月经日期
      happyDate: '', // 受孕日期日期
      // hasSelectedHappyDate: false,  //是否手动选择过受孕日期
      today: new Date(),
      weeks: '',
      days: '',
      ultrasoundDate: new Date(),
      currentDate: '',
      showDatetimePicker: false,
      currentDateType: '',
      result: {
        monthThree: '', // 3月孕期末
        monthSix: '', // 6月孕期末
        babyBornDate: '', // 预产期
        weeks: '', // 孕龄-周
        days: '' // 孕龄-天
      }

    }
  },
  computed: {
    // ...mapGetters(["isWeChat"]),
  },
  async mounted() {
    hiddenTitleBar(true)
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    daysFormatter(value) {
      console.log('daysFormatter', value);
      if (this.weeks > 49 && value && value > 0) {
        this.showOverlay = true
        this.days = null
        return
      }
      // 过滤输入的数字
      if (value > 9) {
        this.days = value.substr(0, 1);
      } else if ((value > 6 && value < 10) || value == 0) {
        this.days = null
        !(this.days || this.weeks) ? this.clearWeekAndDay() : this.handleClacAgeAtUltrasound()
      } else {
        this.days = value
        this.handleClacAgeAtUltrasound()
      }

    },

    weeksFormatter(value) {
      console.log('weeksFormatter', value);
      let max = this.days && this.days > 0 ? 49 : 50
      // 过滤输入的数字
      if (value > max) {
        this.showOverlay = true
        this.weeks = value.substr(0, value.length - 1);
      } else if (value == 0) {
        this.weeks = null
        !(this.days || this.weeks) ? this.clearWeekAndDay() : this.handleClacAgeAtUltrasound()
      } else {
        this.weeks = value
        this.handleClacAgeAtUltrasound()
      }
    },
    clearWeekAndDay() {
      console.log('clearWeekAndDay');
      let today = new Date(this.today)
      this.lastSadDate = today.setDate(today.getDate() - (this.result.weeks * 7 + this.result.days))
      let date = new Date(this.lastSadDate)
      date.setDate(date.getDate() + 14)
      let date1 = new Date(this.lastSadDate)
      date1.setDate(date1.getDate() + 13 * 7)
      let date2 = new Date(this.lastSadDate)
      date2.setDate(date2.getDate() + 26 * 7)

      let date3 = new Date(this.lastSadDate)
      date3.setDate(date3.getDate() + 40 * 7)

      this.happyDate = date
      this.result.monthThree = date1
      this.result.monthSix = date2
      this.result.babyBornDate = date3
    },
    handleClacAgeAtUltrasound() {
      console.log('handleClacAgeAtUltrasound');

      let ultrasoundDate = new Date(this.ultrasoundDate)
      this.lastSadDate = ultrasoundDate.setDate(ultrasoundDate.getDate() - (Number(this.weeks * 7) + Number(this.days)))
      let date = new Date(this.lastSadDate)
      date.setDate(date.getDate() + 14)
      let date1 = new Date(this.lastSadDate)
      date1.setDate(date1.getDate() + 13 * 7)
      let date2 = new Date(this.lastSadDate)
      date2.setDate(date2.getDate() + 26 * 7)

      let date3 = new Date(this.lastSadDate)
      date3.setDate(date3.getDate() + 40 * 7)

      this.happyDate = date
      this.result.monthThree = date1
      this.result.monthSix = date2
      this.result.babyBornDate = date3

      let todaySelected = new Date(this.today).getTime()
      console.log('todaySelected', todaySelected)

      let lastSadDate = new Date(this.lastSadDate).getTime()
      console.log('lastSadDate', lastSadDate)

      if (todaySelected - lastSadDate >= 86400000) {
        let happyButTiredDays = Math.floor((todaySelected - lastSadDate) / 86400000)
        console.log('happyButTiredDays', happyButTiredDays)
        this.result.weeks = Math.floor(happyButTiredDays / 7)
        this.result.days = happyButTiredDays % 7
      } else {
        this.result.weeks = 0
        this.result.days = 0
      }
    },
    timeFormat(val) {
      if (!val) {
        return
      }
      let date = new Date(val)
      let Y = date.getFullYear()
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1)
      let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return Y + '年' + M + '月' + D + '日'
    },
    // 选择日期弹窗  currentDateType决定日期类型
    handleDateConfirm() {
      console.log('currentDate', this.currentDate)
      if (!this.currentDate) {
        return
      }

      if (this.currentDateType == 'today') {
        // 今天  时间选择
        this.today = this.currentDate
        let todaySelected = new Date(this.today).getTime()
        console.log('todaySelected', todaySelected)
        if (!this.lastSadDate) {
          this.showDatetimePicker = false
          return
        }
        let realHappyDate = new Date(this.lastSadDate).getTime()
        console.log('realHappyDate', realHappyDate)
        if (todaySelected - realHappyDate >= 86400000) {
          let happyButTiredDays = Math.floor((todaySelected - realHappyDate) / 86400000)
          console.log('happyButTiredDays', happyButTiredDays)
          this.result.weeks = Math.floor(happyButTiredDays / 7)
          this.result.days = happyButTiredDays % 7
        } else {
          this.result.weeks = 0
          this.result.days = 0
        }
      } else if (this.currentDateType == 'lastSadDate') {
        // 末次月经  时间选择
        this.lastSadDate = this.currentDate
        let date = new Date(this.currentDate)
        date.setDate(date.getDate() + 14)
        let date1 = new Date(this.currentDate)
        date1.setDate(date1.getDate() + 13 * 7)
        let date2 = new Date(this.currentDate)
        date2.setDate(date2.getDate() + 26 * 7)

        let date3 = new Date(this.currentDate)
        date3.setDate(date3.getDate() + 40 * 7)

        this.happyDate = date
        this.result.monthThree = date1
        this.result.monthSix = date2
        this.result.babyBornDate = date3

        let todaySelected = new Date(this.today).getTime()
        console.log('todaySelected', todaySelected)

        let lastSadDate = new Date(this.lastSadDate).getTime()
        console.log('lastSadDate', lastSadDate)

        if (todaySelected - lastSadDate >= 86400000) {
          let happyButTiredDays = Math.floor((todaySelected - lastSadDate) / 86400000)
          console.log('happyButTiredDays', happyButTiredDays)
          this.result.weeks = Math.floor(happyButTiredDays / 7)
          this.result.days = happyButTiredDays % 7
        } else {
          this.result.weeks = 0
          this.result.days = 0
        }
      } else if (this.currentDateType == 'happyDate') {
        // this.hasSelectedHappyDate = true
        // 受孕日期  时间选择
        this.happyDate = this.currentDate

        let date = new Date(this.currentDate)
        date.setDate(date.getDate() - 14)
        let date1 = new Date(date).setDate(date.getDate() + 13 * 7)
        let date2 = new Date(date).setDate(date.getDate() + 26 * 7)
        let date3 = new Date(date).setDate(date.getDate() + 40 * 7)
        this.lastSadDate = date
        this.result.monthThree = date1
        this.result.monthSix = date2
        this.result.babyBornDate = date3

        let todaySelected = new Date(this.today).getTime()
        console.log('todaySelected', todaySelected)

        let lastSadDate = new Date(this.lastSadDate).getTime()
        console.log('lastSadDate', lastSadDate)
        if (todaySelected - lastSadDate >= 86400000) {
          let happyButTiredDays = Math.floor((todaySelected - lastSadDate) / 86400000)
          console.log('happyButTiredDays', happyButTiredDays)
          this.result.weeks = Math.floor(happyButTiredDays / 7)
          this.result.days = happyButTiredDays % 7
        } else {
          this.result.weeks = 0
          this.result.days = 0
        }
      } else if (this.currentDateType == 'babyBornDate') {
        // this.hasSelectedHappyDate = true
        // 受孕日期  时间选择
        this.result.babyBornDate = this.currentDate
        let date = new Date(this.currentDate)
        date.setDate(date.getDate() - 40 * 7)
        let date1 = new Date(date).setDate(date.getDate() + 14)
        let date2 = new Date(date).setDate(date.getDate() + 13 * 7)
        let date3 = new Date(date).setDate(date.getDate() + 26 * 7)
        this.lastSadDate = date
        this.happyDate = date1
        this.result.monthThree = date2
        this.result.monthSix = date3

        let todaySelected = new Date(this.today).getTime()
        console.log('todaySelected', todaySelected)

        let lastSadDate = new Date(this.lastSadDate).getTime()
        console.log('lastSadDate', lastSadDate)
        if (todaySelected - lastSadDate >= 86400000) {
          let happyButTiredDays = Math.floor((todaySelected - lastSadDate) / 86400000)
          console.log('happyButTiredDays', happyButTiredDays)
          this.result.weeks = Math.floor(happyButTiredDays / 7)
          this.result.days = happyButTiredDays % 7
        } else {
          this.result.weeks = 0
          this.result.days = 0
        }
      } else if (this.currentDateType = 'ultrasoundDate') {
        console.log('ultrasoundDate');
        this.ultrasoundDate = this.currentDate
        let ultrasoundDate = new Date(this.ultrasoundDate)
        this.lastSadDate = ultrasoundDate.setDate(ultrasoundDate.getDate() - (Number(this.weeks * 7) + Number(this.days)))
        let date = new Date(this.lastSadDate)
        date.setDate(date.getDate() + 14)
        let date1 = new Date(this.lastSadDate)
        date1.setDate(date1.getDate() + 13 * 7)
        let date2 = new Date(this.lastSadDate)
        date2.setDate(date2.getDate() + 26 * 7)

        let date3 = new Date(this.lastSadDate)
        date3.setDate(date3.getDate() + 40 * 7)

        this.happyDate = date
        this.result.monthThree = date1
        this.result.monthSix = date2
        this.result.babyBornDate = date3

        let todaySelected = new Date(this.today).getTime()
        console.log('todaySelected', todaySelected)

        let lastSadDate = new Date(this.lastSadDate).getTime()
        console.log('lastSadDate', lastSadDate)

        if (todaySelected - lastSadDate >= 86400000) {
          let happyButTiredDays = Math.floor((todaySelected - lastSadDate) / 86400000)
          console.log('happyButTiredDays', happyButTiredDays)
          this.result.weeks = Math.floor(happyButTiredDays / 7)
          this.result.days = happyButTiredDays % 7
        } else {
          this.result.weeks = 0
          this.result.days = 0
        }
      } else {
        return
      }
      this.showDatetimePicker = false
    },
    handleDateCancel() {
      console.log('currentDate', this.currentDate)
      this.showDatetimePicker = false
      // this.currentDateType='today'
    },
    handlePickDate(type) {
      let canPick = !((this.days && this.days > 0) || (this.weeks && this.weeks > 0))

      if (type == 'today') {
        this.currentDate = this.today ? new Date(this.today) : new Date()
        this.currentDateType = type
        this.showDatetimePicker = true
      } else if (type == 'lastSadDate' && canPick) {
        this.currentDate = this.lastSadDate ? new Date(this.lastSadDate) : new Date()
        this.currentDateType = type
        this.showDatetimePicker = true
      } else if (type == 'happyDate' && canPick) {
        this.currentDate = this.happyDate ? new Date(this.happyDate) : new Date()
        this.currentDateType = type
        this.showDatetimePicker = true
      } else if (type == 'babyBornDate' && canPick) {
        this.currentDate = this.result.babyBornDate ? new Date(this.result.babyBornDate) : new Date()
        this.currentDateType = type
        this.showDatetimePicker = true
      } else if (type == 'ultrasoundDate') {
        this.currentDate = this.ultrasoundDate ? new Date(this.ultrasoundDate) : new Date()
        this.currentDateType = type
        this.showDatetimePicker = true
      } else {
        return
      }

    },
    // MDCalc(z) {
    //   var lmpid = $("#lmp").val();    //末次月经日期
    //   var ddid = $("#duedates").val();  //到期日（估计预产期）
    //   var wks = $("#wks").val();  //当前胎龄-周
    //   var days = $("#days").val();  //当前胎龄-天
    //   if (wks & ddid || wks && lmpid) {
    //     alert("请只输入三中选项之一对应的数字。谢谢!"); return false
    //   }
    //   if (ddid) {
    //     var today = Date.today();
    //     var dd = Date.parse(ddid);
    //     var lmp = Date.parse(ddid).add(-40).weeks();
    //     lmps = lmp.toString("ddd M/d/yyyy");
    //     var conception = Date.parse(ddid).add(-38).weeks();
    //     conception = conception.toString("ddd M/d/yyyy");
    //     var ega = today - lmp; ega = ega / 864e5;
    //     var weeks = parseInt(ega / 7);
    //     if (weeks > 42) {
    //       alert("一种可能是怀孕已经超过42周，孩子现在即将出生；另一种可能是末次月经日期计算错误或输入错误，请仔细检查。"); return false
    //     }
    //     var days = ega % 7;
    //     days = Math.round(days * 1) / 1;
    //     if (days == 7) {
    //       weeks = weeks + 1; var result = "正好" + weeks + " 星期"
    //     } else {
    //       var result = weeks + " 星期 和 " + days + "/7 天"
    //     }
    //     Text(result);
    //     Text2(lmps);
    //     Text3(" ");
    //     Text4(conception)
    //   }
    //   if (lmpid) {
    //     var today = Date.today(); var lmp = Date.parse(lmpid);
    //     if (lmp > today) {
    //       alert("Hmm. 末次月经日期不应该在今天之后. 检查一下年份."); return false
    //     }
    //     var edd = Date.parse(lmpid).add(40).weeks();
    //     edd = edd.toString("ddd M/d/yyyy");
    //     var conception = Date.parse(lmpid).add(14).days();
    //     conception = conception.toString("ddd M/d/yyyy");
    //     var ega = today - lmp; ega = ega / 864e5;
    //     var weeks = parseInt(ega / 7);
    //     if (weeks > 42) {
    //       alert("一种可能是怀孕已经超过42周，孩子现在即将出生；另一种可能是末次月经日期计算错误或输入错误，请仔细检查。"); return false
    //     }
    //     var days = ega % 7; days = Math.round(days * 1) / 1;
    //     if (days == 7) {
    //       weeks = weeks + 1; var result = "正好" + weeks + " 星期"
    //     } else {
    //       var result = weeks + " 星期 和 " + days + "/7 天"
    //     }
    //     Text(result);
    //     Text2(" ");
    //     Text3(edd);
    //     Text4(conception)
    //   }
    //   if (wks) {
    //     if (!days) { days = 0 }
    //     wks *= -1; days *= -1;
    //     var today = Date.today();
    //     var lmp = today.add(wks).weeks();
    //     if (days != 0) { lmps = lmp.add(days).days() } else { lmps = lmp }
    //     Text2(lmps.toString("ddd M/d/yyyy"));
    //     var conception = lmp.add(14).days();
    //     Text4(conception.toString("ddd M/d/yyyy"));
    //     var edd = lmp.add(40).weeks();
    //     Text3(edd.toString("ddd M/d/yyyy"))
    //   }
    //   $("#units").hide()
    // },
    // 获取公式详情
    async getFormulaDetail() {
      var params = {
        uuid: this.formulaId
      }
      try {
        const res = await formulaDetail(params)
        this.formulaInfo = res
      } catch (error) {
        console.log(error)
      }
    },
    // 获取公式收藏状态
    async getFormulaCollect() {
      var params = {
        uuid: this.formulaId,
        collectType: 'FORMULA', // 收藏类型( DRUG,GUIDE,FORMULA,NEWS)
        contentType: 0
      }
      try {
        const res = await getCollectInfoById(params)
        if (res.result) {
          this.collectStatus = res.result
        }
      } catch (error) {
        console.log(error)
      }
    },
    /** 动态插入从后端取到的js片段 */
    appendScriptFun(jsStr) {
      let hasCalculationScript = document.getElementById('calculation—script')
      if (hasCalculationScript) {
        return document.body.removeChild(hasCalculationScript)
      }
      let scriptCalculation = document.createElement('script')
      scriptCalculation.id = 'calculation—script'
      scriptCalculation.innerHTML = jsStr
      document.body.appendChild(scriptCalculation)
    },
    /** 简介收起 or 展开 */
    showAllDesc() {
      if (this.isExpand == 1) {
        setTimeout(() => {
          // 设置延时，否则埋点不对
          this.isExpand = 2
        }, 0)
      } else if (this.isExpand == 2) {
        setTimeout(() => {
          this.isExpand = 1
        }, 0)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ObGyn/PregnancyWeek.vue